import mutations from './healthInsurancePartner.mutations'
import actions from './healthInsurancePartner.actions'
import getters from './healthInsurancePartner.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
